const EventPage = '/studio-presenter/teams/:teamId/events/:eventId',
  BroadcastPage = `${EventPage}/broadcasts/:broadcastId`,
  JoinPage = `${BroadcastPage}/join`,
  ReadinessCheckPage = '/studio-presenter/check',
  JoinV2Page = `${BroadcastPage}/join-new`;

const AppPaths = {
  EventPage,
  BroadcastPage,
  JoinPage,
  ReadinessCheckPage,
  JoinV2Page
};

export default AppPaths;
